
import { convertDateBrComHora } from "@/core/helpers/convertDate";
import {
  defineComponent,
  PropType,
  onMounted,
  reactive,
  watch,
  toRefs,
} from "vue";
export default defineComponent({
  name: "Grade-Edicao",
  data() {
    return {
      dataInclusao: "",
      dataAlteracao: "",
    };
  },
  props: {
    propPayload: {
      type: Object as PropType<any>,
      required: true,
      default: () => {
        return {};
      },
    },
    porpHideHr: {
      type: Boolean,
      required: false,
      default: false,
    },
    porpHideDataInclusao: {
      type: Boolean,
      required: false,
      default: false,
    },
    porpHideUsuarioInclusao: {
      type: Boolean,
      required: false,
      default: false,
    },
    porpHideUsuarioAlteracao: {
      type: Boolean,
      required: false,
      default: false,
    },
    porpHideDataAlteracao: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const data = reactive({
      dataInclusao: "",
      dataAlteracao: "",
    });
    onMounted(() => {
      data.dataInclusao = convertDateBrComHora(props.propPayload.data_inclusao);
      data.dataAlteracao = convertDateBrComHora(
        props.propPayload.data_alteracao
      );
    });
    watch(
      () => props.propPayload,
      (payload: any) => {
        data.dataInclusao = convertDateBrComHora(payload.data_inclusao);
        data.dataAlteracao = convertDateBrComHora(payload.data_alteracao);
      }
    );

    return {
      ...toRefs(data),
    };
  },
});
